import React from 'react'
import { Table, NumberFormatter, Button } from '@mantine/core'
import dayjs from 'dayjs'
import { IconInfoCircle } from '@tabler/icons-react'


const TableUserOrders = ({ label, data }) => {

  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.order_code}</Table.Td>
        <Table.Td>{dayjs(val.created_at).format('DD-MM-YYYY HH:mm:ss')}</Table.Td>
        <Table.Td>{val.customer_name}</Table.Td>
        <Table.Td>{val.agent ? val.agent.name : '-'}</Table.Td>
        <Table.Td>{val.sales ? val.sales.name : '-'}</Table.Td>
        <Table.Td tt='capitalize'>{val.payment_status}</Table.Td>
        <Table.Td tt='capitalize'>{val.order_status}</Table.Td>
        <Table.Td>
          <NumberFormatter prefix={`${val.order_currency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={val.grand_total} />
        </Table.Td>
        <Table.Td>
          <Button 
            size='compact-xs'
            variant='transparent'
            onClick={() => window.open(`/order/${val.id}`, '_blank')}
            leftSection={<IconInfoCircle size={14} />}
          >
            Detail
          </Button>
        </Table.Td>
      </Table.Tr>
    )
  })

  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableUserOrders